<template>
  <span id="print-invoice-bulk" v-if="invoices.total">
    <el-button id="btn-print-invoice-bulk" v-if="!isInBulkPrintingInvoices && !isDropDownItem" type="success" plain @click="handleToggleBulkPrint(true)" size="mini">{{ $t('invoices.printInvoices') }}</el-button>
    <el-dropdown-item id="btn-print-invoice-bulk-dropdown-item" v-if="!isInBulkPrintingInvoices && isDropDownItem" type="success" plain @click.native="handleToggleBulkPrint(true)" size="mini">
      <span class="more-actions-option">{{ $t('invoices.printInvoices') }}</span>
    </el-dropdown-item>
    <el-button id="btn-cancel-print-invoice-bulk" v-if="isInBulkPrintingInvoices && !isDropDownItem" type="default" @click="handleToggleBulkPrint(false)" size="mini">{{ $t('common.cancel') }}</el-button>
    <el-button id="btn-submit-print-invoice-bulk" v-if="isInBulkPrintingInvoices && !isDropDownItem" type="primary" @click="bulkPrint" size="mini">{{ $t('invoices.printInvoices') }}</el-button>
  </span>
</template>

<script>
import { Loading, Message } from 'element-ui';
import { mapGetters } from 'vuex';
import constants from '@/utils/constants';

export default {
  name: 'PrintInvoiceBulk',
  props: {
    isDropDownItem: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['invoices', 'isInBulkPrintingInvoices'])
  },
  data() {
    return {};
  },
  methods: {
    handleToggleBulkPrint(isInBulkPrinting) {
      this.$store.dispatch('invoices/setIsInBulkPrinting', isInBulkPrinting);
    },
    async bulkPrint() {
      if (this.invoices.selectAllChecked || this.invoices.selectedIdsIncluded.length) {
        Message.closeAll();
        const loading = Loading.service(constants.LOADING.PRINT_INVOICES_CONFIG);
        await this.$store.dispatch('invoices/bulkPrint');
        loading.close();
        this.handleToggleBulkPrint(false);
      } else {
        this.$message.warning(this.$t('invoices.list.selectInvoicesToPrint'));
      }
    }
  },
  beforeDestroy() {
    this.handleToggleBulkPrint(false);
  }
};
</script>
<style rel="stylesheet/scss" lang="scss">
#print-invoice-bulk {
  .el-button--success {
    margin-left: 10px;
  }
}
#print-invoice-bulk-dialog {
  .el-button {
    margin-bottom: 10px;
    width: 100%;
  }
}
</style>
